import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CheckIcon, StarIcon } from 'lucide-react';
const CHECKOUT_BASIC = 'https://checkout.recursodigital.shop/cart/41301282291770:1';
const CHECKOUT_INTERMEDIATE = 'https://checkout.recursodigital.shop/cart/41301282291770:1';
const CHECKOUT_COMPLETE = 'https://checkout.recursodigital.shop/cart/41301282291770:1';
type PackType = 'basic' | 'intermediate' | 'complete';
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<PackType>('complete');
  const getCheckoutUrl = () => {
    switch (selectedPack) {
      case 'basic':
        return CHECKOUT_BASIC;
      case 'intermediate':
        return CHECKOUT_INTERMEDIATE;
      case 'complete':
        return CHECKOUT_COMPLETE;
    }
  };
  return <section id="pricing" className="w-full bg-[#0a0a0a] py-12 md:py-16 pb-6 md:pb-8 px-4" data-id="element-299">
      <div className="max-w-3xl mx-auto" data-id="element-300">
        {/* Countdown */}
        <div className="text-center mb-10" data-id="element-301">
          <p className="text-yellow-400 font-bold text-lg md:text-xl mb-4 font-heading" data-id="element-302">
            ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </p>
          <CountdownTimer data-id="element-303" />
          <p className="text-gray-400 text-sm mt-4 font-body" data-id="element-304">
            Después sube el precio y no vuelve a bajar
          </p>
        </div>

        <div className="text-center mb-8" data-id="element-305">
          <h2 className="text-3xl md:text-4xl font-black font-heading text-white mb-2" data-id="element-306">
            Elige tu <span className="text-yellow-400" data-id="element-307">MegaPack:</span>
          </h2>
          <p className="text-gray-400 font-body" data-id="element-308">
            Todas las opciones incluyen los 3 bonos estratégicos
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-309">
          {/* Pack Básico */}
          <div onClick={() => setSelectedPack('basic')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-300 flex items-center gap-4 ${selectedPack === 'basic' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-310">
            {/* Radio Button */}
            <div className="flex-shrink-0" data-id="element-311">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 'basic' ? 'border-yellow-400' : 'border-gray-500'}`} data-id="element-312">
                {selectedPack === 'basic' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-313" />}
              </div>
            </div>

            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-314">
              <div data-id="element-315">
                <div className="flex items-center gap-2 mb-1" data-id="element-316">
                  <span className="text-xl" data-id="element-317">📘</span>
                  <h3 className="text-lg md:text-xl font-black font-heading text-white" data-id="element-318">
                    PACK BÁSICO
                  </h3>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-body" data-id="element-319">
                  5 tomos + 3 bonos
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-320">
                <p className="text-sm text-gray-500 line-through font-body" data-id="element-321">
                  ARS 27.990
                </p>
                <p className="text-2xl md:text-3xl font-black font-heading text-white" data-id="element-322">
                  ARS 19.990
                </p>
              </div>
            </div>
          </div>

          {/* Pack Completo */}
          <div onClick={() => setSelectedPack('complete')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-300 flex items-start md:items-center gap-4 ${selectedPack === 'complete' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.25)] scale-[1.02] md:scale-105 z-10 relative' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-323">
            {/* Radio Button */}
            <div className="flex-shrink-0 mt-2 md:mt-0" data-id="element-324">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 'complete' ? 'border-yellow-400' : 'border-gray-500'}`} data-id="element-325">
                {selectedPack === 'complete' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-326" />}
              </div>
            </div>

            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-327">
              <div data-id="element-328">
                <div className="flex items-center gap-2 mb-2" data-id="element-329">
                  <span className="text-xl" data-id="element-330">🏆</span>
                  <h3 className="text-lg md:text-xl font-black font-heading text-white" data-id="element-331">
                    PACK COMPLETO
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-332">
                  <span className="bg-yellow-400 text-black text-xs font-bold px-2 py-1 rounded flex items-center gap-1 font-heading" data-id="element-333">
                    <StarIcon className="w-3 h-3 fill-black" data-id="element-334" /> MÁS ELEGIDO
                  </span>
                  <span className="border border-yellow-600 text-yellow-500 text-xs font-bold px-2 py-1 rounded font-heading" data-id="element-335">
                    AHORRAS USD 7.90
                  </span>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-body mb-2" data-id="element-336">
                  Todo lo anterior +
                </p>
                <ul className="space-y-1" data-id="element-337">
                  <li className="text-sm md:text-base text-gray-300 font-body flex items-start gap-2" data-id="element-338">
                    <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-339" />
                    Crianza digital avanzada
                  </li>
                  <li className="text-sm md:text-base text-gray-300 font-body flex items-start gap-2" data-id="element-340">
                    <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-341" />
                    Sistema de personalización y entorno familiar
                  </li>
                </ul>
              </div>
              <div className="text-left md:text-right mt-2 md:mt-0" data-id="element-342">
                <p className="text-sm text-gray-500 line-through font-body" data-id="element-343">
                  ARS 79.990
                </p>
                <p className="text-3xl md:text-4xl font-black font-heading text-yellow-400" data-id="element-344">
                  ARS 27.990
                </p>
              </div>
            </div>
          </div>

          {/* Pack Intermedio */}
          <div onClick={() => setSelectedPack('intermediate')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-300 flex items-center gap-4 ${selectedPack === 'intermediate' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-345">
            {/* Radio Button */}
            <div className="flex-shrink-0" data-id="element-346">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 'intermediate' ? 'border-yellow-400' : 'border-gray-500'}`} data-id="element-347">
                {selectedPack === 'intermediate' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-348" />}
              </div>
            </div>

            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-349">
              <div data-id="element-350">
                <div className="flex items-center gap-2 mb-1" data-id="element-351">
                  <span className="text-xl" data-id="element-352">📗</span>
                  <h3 className="text-lg md:text-xl font-black font-heading text-white" data-id="element-353">
                    PACK INTERMEDIO
                  </h3>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-body" data-id="element-354">
                  Pack Básico + Manual completo de comunicación parental
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-355">
                <p className="text-sm text-gray-500 line-through font-body" data-id="element-356">
                  ARS 49.990
                </p>
                <p className="text-2xl md:text-3xl font-black font-heading text-white" data-id="element-357">
                  ARS 23.990
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="mt-8" data-id="element-358">
          <a href={getCheckoutUrl()} className="block w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black md:text-2xl py-5 rounded-xl text-center transition-colors duration-200 cursor-pointer font-heading shadow-lg text-[18px]" data-id="element-359">
            👉 QUIERO MI MEGAPACK AHORA
          </a>

          {/* Trust badges */}
          <div className="flex flex-wrap justify-center gap-6 mt-6 text-sm md:text-base text-gray-400 font-body" data-id="element-360">
            <span className="flex items-center gap-1" data-id="element-361">🔒 Pago seguro</span>
            <span className="flex items-center gap-1" data-id="element-362">⚡ Acceso inmediato</span>
            <span className="flex items-center gap-1" data-id="element-363">🛡️ Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}